<template>
  <div class="calendars">
    <div class="cal-section">
      <div class="header">
        <h2>Versenynaptár</h2>
        <button v-if="isAdmin || isAssistant" class="btn-primary" @click="toggleForm('comp')">+ Verseny</button>
      </div>
      <div v-if="showComp" class="form card">
        <input v-model="comp.title" placeholder="Megnevezés" class="modern-input" />
        <input v-model="comp.location" placeholder="Helyszín" class="modern-input" />
        <input type="date" v-model="comp.comp_date" placeholder="Dátum" class="modern-input" />
        <textarea v-model="comp.notes" placeholder="Megjegyzés" class="modern-input"></textarea>
        <div class="child-select">
          <label>Résztvevő versenyzők:</label>
          <div class="child-list">
            <label v-for="child in children" :key="child.id" class="child-option">
              <input type="checkbox" :value="child.id" v-model="comp.child_ids" />
              {{ child.family_name }} {{ child.sure_name }}
            </label>
          </div>
        </div>
        <button class="btn-primary" @click="submitComp">Mentés</button>
      </div>
      <div class="table-wrapper">
        <table class="tbl">
          <thead><tr><th>Dátum</th><th>Verseny</th><th>Helyszín</th><th v-if="isAdmin || isAssistant"></th></tr></thead>
          <tbody>
            <tr v-for="e in competitions" :key="e.id">
              <td>{{ e.comp_date }}</td><td>{{ e.title }}</td><td>{{ e.location }}</td>
              <td v-if="isAdmin || isAssistant"><button class="btn-danger btn-sm" @click="removeComp(e.id)">Törlés</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="cal-section">
      <div class="header">
        <h2>Eseménynaptár</h2>
        <button v-if="isAdmin || isAssistant" class="btn-primary" @click="toggleForm('evt')">+ Esemény</button>
      </div>
      <div v-if="showEvt" class="form card">
        <input v-model="evt.title" placeholder="Megnevezés" class="modern-input" />
        <input v-model="evt.location" placeholder="Helyszín" class="modern-input" />
        <input type="date" v-model="evt.event_date" placeholder="Dátum" class="modern-input" />
        <textarea v-model="evt.notes" placeholder="Megjegyzés" class="modern-input"></textarea>
        <button class="btn-primary" @click="submitEvt">Mentés</button>
      </div>
      <div class="table-wrapper">
        <table class="tbl">
          <thead><tr><th>Dátum</th><th>Esemény</th><th>Helyszín</th><th v-if="isAdmin || isAssistant"></th></tr></thead>
          <tbody>
            <tr v-for="e in events" :key="e.id">
              <td>{{ e.event_date }}</td><td>{{ e.title }}</td><td>{{ e.location }}</td>
              <td v-if="isAdmin || isAssistant"><button class="btn-danger btn-sm" @click="removeEvt(e.id)">Törlés</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'CalendarsItem',
  data() {
    return {
      competitions: [],
      events: [],
      showComp: false,
      showEvt: false,
      comp: { title: '', location: '', comp_date: '', notes: '', child_ids: [] },
      evt: { title: '', location: '', event_date: '', notes: '' },
      children: [],
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    isAssistant() {
      return this.$store.getters.isAssistant;
    }
  },
  mounted() {
    this.fetchAll();
    this.fetchChildren();
  },
  methods: {
    async fetchAll() {
      const [c, e] = await Promise.all([
        axios.get(this.$BACKEND_HOST + '/api/competitions'),
        axios.get(this.$BACKEND_HOST + '/api/calendar-events'),
      ]);
      this.competitions = c.data.events || [];
      this.events = e.data.events || [];
    },
    async fetchChildren() {
      try {
        const r = await axios.get(this.$BACKEND_HOST + '/api/message/dancers');
        this.children = r.data.dancers || [];
      } catch (err) {
        console.error('Error fetching children:', err);
      }
    },
    toggleForm(which) {
      if (which === 'comp') this.showComp = !this.showComp;
      else this.showEvt = !this.showEvt;
    },
    async submitComp() {
      const payload = {
        title: this.comp.title,
        location: this.comp.location,
        comp_date: this.comp.comp_date,
        notes: this.comp.notes,
        child_ids: this.comp.child_ids,
      };
      await axios.post(this.$BACKEND_HOST + '/api/competitions', payload);
      this.comp = { title: '', location: '', comp_date: '', notes: '', child_ids: [] };
      this.showComp = false;
      this.fetchAll();
    },
    async submitEvt() {
      await axios.post(this.$BACKEND_HOST + '/api/calendar-events', this.evt);
      this.evt = { title: '', location: '', event_date: '', notes: '' };
      this.showEvt = false;
      this.fetchAll();
    },
    async removeComp(id) {
      await axios.delete(this.$BACKEND_HOST + `/api/competitions/${id}`);
      this.fetchAll();
    },
    async removeEvt(id) {
      await axios.delete(this.$BACKEND_HOST + `/api/calendar-events/${id}`);
      this.fetchAll();
    },
  },
};
</script>

<style scoped>
.calendars { max-width: 1000px; margin: 0 auto; padding: 1.5rem; display: grid; gap: 2rem; }
.header { display: flex; justify-content: space-between; align-items: center; }
.card { background: var(--card-bg); border: 1px solid var(--color-border); border-radius: 12px; padding: 1rem; margin-bottom: 1rem; }
.form { display: flex; flex-direction: column; gap: 0.6rem; }
.tbl { width: 100%; border-collapse: collapse; }
.tbl th, .tbl td { padding: 0.5rem; border-bottom: 1px solid var(--color-border); text-align: left; }
.btn-primary { background: var(--button-primary); color: #fff; border: none; padding: 0.5rem 1rem; border-radius: 8px; cursor: pointer; }
.btn-danger { background: #d33; color: #fff; border: none; padding: 0.35rem 0.7rem; border-radius: 6px; cursor: pointer; }
.btn-sm { font-size: 0.8rem; }
.child-select { display: flex; flex-direction: column; gap: 0.4rem; }
.table-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  max-width: 100%;
}

@media (max-width: 768px) {
  .calendars { padding: 1rem 0.5rem; gap: 1.25rem; }
  .header { flex-direction: row; justify-content: space-between; }
  .header h2 { font-size: 1.25rem; }
  .tbl th, .tbl td { padding: 0.4rem; font-size: 0.85rem; white-space: nowrap; }
}
</style>
